import { render } from "./PdfContainerView.vue?vue&type=template&id=4bd4ba78&scoped=true"
import script from "./PdfContainerView.vue?vue&type=script&lang=js"
export * from "./PdfContainerView.vue?vue&type=script&lang=js"

import "./PdfContainerView.vue?vue&type=style&index=0&id=4bd4ba78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd4ba78"]])

export default __exports__